// extracted by mini-css-extract-plugin
export default {"container":"SmallScreenSection_container__nSxaq","testTwitch":"SmallScreenSection_testTwitch__6B1hz"};